import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const feedbackApi = createApi({
    reducerPath: 'feedbackApi',
    baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
    tagTypes: ['feedback'],
    endpoints: (builder) => ({
        saveCustomerFeedback: builder.mutation({
            query(body) {
                return {
                    url: `${spotFinder.customerFeedbackController.saveCustomerFeedback}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,


                };
            },
        }),
        getAllCustomerFeedback: builder.mutation({
          query({ token, payload }) {
              return {
                  url: `${spotFinder.customerFeedbackController.getAllCustomerFeedback}`,
                  method: "POST",
                  headers: token ? { Authorization: `Bearer ${token}` } : {},
                  body: payload,
              };
          },
      }),
        findCustomerFeedbackByBookingId: builder.mutation({
            query({bookingId, token }) {
              return {
                url: `${spotFinder.customerFeedbackController.findCustomerFeedbackByBookingId}/${bookingId}`,
                method: "GET",
                headers: token
                ? { Authorization: `Bearer ${token}` }
                : {}
              };
            },
        }),
    }),


});

export const { useSaveCustomerFeedbackMutation,
    useGetAllCustomerFeedbackMutation,
    useFindCustomerFeedbackByBookingIdMutation,
 } = feedbackApi;
